import { ReactNode } from 'react';

import { Helmet, HelmetProvider } from 'react-helmet-async';

import { stripHtml } from 'utils/dom';

interface DocumentHeadProps {
  children?: ReactNode;
  pageTitle?: string;
}

const getFullPageTitle = (specificPageTitle: string) =>
  specificPageTitle
    ? stripHtml(specificPageTitle)
    : 'Pathway: Learning and Training Resources';

const DocumentHead: React.FC<DocumentHeadProps> = ({
  pageTitle = '',
  children,
}) => (
  <HelmetProvider>
    <Helmet>
      <title>{getFullPageTitle(pageTitle)}</title>
      {children}
    </Helmet>
  </HelmetProvider>
);

export default DocumentHead;
